module.exports = __webpack_public_path__ + "img/bg-img-2-dark.5ebcaf80.png";